import { takeLatest, call, put } from 'redux-saga/effects'
import {
    addProjectAPI, projectAssignEmployeeAPI, projectDetailAPI,
    projectListAPI, projectRemoveEmployeeAPI, updateProjectDetailAPI,
    requestProjectAPI, rejectProjectRequestAPI
} from '../api-requests/project';
import {
    addProjectRequestError, addProjectRequestSuccess, projectAssignEmployeeRequestError,
    projectAssignEmployeeRequestSuccess, projectDetailRequestError, projectDetailRequestSuccess,
    projectListRequestError, projectListRequestSuccess, projectRemoveEmployeeRequestError,
    projectRemoveEmployeeRequestSuccess, updateProjectDetailRequestError, updateProjectDetailRequestSuccess,
    requestProjectRequestError, requestProjectRequestSuccess, rejectEmployeeProjectRequestError,
    rejectEmployeeProjectRequestSuccess
} from './project.action';
import { ProjectActionTypes } from './project.types'
import { displayConsoleLog } from '../../utils/Utils'
import { decryptResponseData } from '../../utils/DataDecryptionUtils';

function* handleRejectProjectRequest({ payload }) {
    try {
        const response = yield call(rejectProjectRequestAPI, payload);
        if (response.status >= 200 && response.status < 300) {
            const { data } = response
            const decryptedData = decryptResponseData(data)
            if (decryptedData.data !== null) {
                yield put(rejectEmployeeProjectRequestSuccess(decryptedData))
            } else {
                yield put(rejectEmployeeProjectRequestError(decryptedData))
            }
        } else {
            throw response
        }
    } catch (error) {
        displayConsoleLog(error.response.data)
        yield put(rejectEmployeeProjectRequestError(error.response.data))
    }
}

export function* rejectProjectRequestReq() {
    yield takeLatest(ProjectActionTypes.REJECT_EMPLOYEE_PROJECT_REQUEST, handleRejectProjectRequest)
}

function* handleRequestProject({ payload }) {
    try {
        const response = yield call(requestProjectAPI, payload);
        if (response.status >= 200 && response.status < 300) {
            const { data } = response
            const decryptedData = decryptResponseData(data)
            if (decryptedData.data !== null) {
                yield put(requestProjectRequestSuccess(decryptedData))
            } else {
                yield put(requestProjectRequestError(decryptedData))
            }
        } else {
            throw response
        }
    } catch (error) {
        displayConsoleLog(error.response.data)
        yield put(requestProjectRequestError(error.response.data))
    }
}

export function* requestProjectReq() {
    yield takeLatest(ProjectActionTypes.REQUEST_PROJECT_REQUEST, handleRequestProject)
}

function* handleUpdateProjectDetail({ payload }) {
    try {
        const response = yield call(updateProjectDetailAPI, payload);
        if (response.status >= 200 && response.status < 300) {
            const { data } = response
            const decryptedData = decryptResponseData(data)
            if (decryptedData.data !== null) {
                yield put(updateProjectDetailRequestSuccess(decryptedData))
            } else {
                yield put(updateProjectDetailRequestError(decryptedData))
            }
        } else {
            throw response
        }
    } catch (error) {
        displayConsoleLog(error.response.data)
        yield put(updateProjectDetailRequestError(error.response.data))
    }
}

export function* updateProjectDetailReq() {
    yield takeLatest(ProjectActionTypes.PROJECT_UPATE_DETAIL_REQUEST, handleUpdateProjectDetail)
}

function* handleProjectRemoveEmployee({ payload }) {
    try {
        const response = yield call(projectRemoveEmployeeAPI, payload);
        if (response.status >= 200 && response.status < 300) {
            const { data } = response
            const decryptedData = decryptResponseData(data)
            if (decryptedData.data !== null) {
                yield put(projectRemoveEmployeeRequestSuccess(decryptedData))
            } else {
                yield put(projectRemoveEmployeeRequestError(decryptedData))
            }
        } else {
            throw response
        }
    } catch (error) {
        displayConsoleLog(error.response.data)
        yield put(projectRemoveEmployeeRequestError(error.response.data))
    }
}

export function* projectRemoveEmployeeReq() {
    yield takeLatest(ProjectActionTypes.PROJECT_REMOVE_EMPLOYEE_REQUEST, handleProjectRemoveEmployee)
}

function* handleProjectList({ payload }) {
    try {
        const response = yield call(projectListAPI, payload);
        if (response.status >= 200 && response.status < 300) {
            const { data } = response
            const decryptedData = decryptResponseData(data)
            if (decryptedData.data !== null) {
                yield put(projectListRequestSuccess(decryptedData))
            } else {
                yield put(projectListRequestError(decryptedData))
            }
        } else {
            throw response
        }
    } catch (error) {
        displayConsoleLog(error.response.data)
        yield put(projectListRequestError(error.response.data))
    }
}

export function* projectListReq() {
    yield takeLatest(ProjectActionTypes.PROJECT_LIST_REQUEST, handleProjectList)
}

function* handleProjectDetail({ payload }) {
    try {
        const response = yield call(projectDetailAPI, payload);
        if (response.status >= 200 && response.status < 300) {
            const { data } = response
            const decryptedData = decryptResponseData(data)
            if (decryptedData.data !== null) {
                yield put(projectDetailRequestSuccess(decryptedData))
            } else {
                yield put(projectDetailRequestError(decryptedData))
            }
        } else {
            throw response
        }
    } catch (error) {
        displayConsoleLog(error.response.data)
        yield put(projectDetailRequestError(error.response.data))
    }
}

export function* projectDetailReq() {
    yield takeLatest(ProjectActionTypes.PROJECT_DETAIL_REQUEST, handleProjectDetail)
}

function* handleProjectAssignEmployee({ payload }) {
    try {
        const response = yield call(projectAssignEmployeeAPI, payload);
        if (response.status >= 200 && response.status < 300) {
            const { data } = response
            const decryptedData = decryptResponseData(data)
            if (decryptedData.data !== null) {
                yield put(projectAssignEmployeeRequestSuccess(decryptedData))
            } else {
                yield put(projectAssignEmployeeRequestError(decryptedData))
            }
        } else {
            throw response
        }
    } catch (error) {
        displayConsoleLog(error.response.data)
        yield put(projectAssignEmployeeRequestError(error.response.data))
    }
}

export function* projectAssignEmployeeReq() {
    yield takeLatest(ProjectActionTypes.PROJECT_ASSIGN_EMPLOYEE_REQUEST, handleProjectAssignEmployee)
}

function* handleAddProject({ payload }) {
    try {
        const response = yield call(addProjectAPI, payload);
        if (response.status >= 200 && response.status < 300) {
            const { data } = response
            const decryptedData = decryptResponseData(data)
            if (decryptedData.data !== null) {
                yield put(addProjectRequestSuccess(decryptedData))
            } else {
                yield put(addProjectRequestError(decryptedData))
            }
        } else {
            throw response
        }
    } catch (error) {
        displayConsoleLog(error.response.data)
        yield put(addProjectRequestError(error.response.data))
    }
}

export function* addProjectReq() {
    yield takeLatest(ProjectActionTypes.ADD_PROJECT_REQUEST, handleAddProject)
}